import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { AvailableCashBalance } from '../AvailableCashBalance';
import { PaidExpensesVsReceivedIncomesPieChart } from '../PaidExpensesVsReceviedIncomesPieChart';
import { ExpensesToBePaidVsIncomesToBeReceived } from '../ExpensesToBePaidVsIncomesToBeReceivedPieChart';

export function OverviewTabMobile({ period }) {
  return (
    <Stack spacing={2}>
      <AvailableCashBalance {...period} />
      <PaidExpensesVsReceivedIncomesPieChart {...period} />
      <ExpensesToBePaidVsIncomesToBeReceived {...period} />
    </Stack>
  );
}

OverviewTabMobile.propTypes = {
  period: PropTypes.shape({
    selectedDate: PropTypes.object.isRequired,
    viewByYear: PropTypes.bool.isRequired,
    viewAllPeriod: PropTypes.bool.isRequired,
  }).isRequired,
};
